module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as3609-2036a1b8098b9e9436250af14087cbf3.jpg";